export default {
  form: {
    country: {
      label: 'Kraj',
      placeholder: 'Wybierz kraj',
    },
  },
};
